<template>
  <div class="drop-spot-item" @click="onClick">
    <div
      class="image"
      :class="{ noImg: selectedSpot.spot_images.length === 0 }"
    >
      <img :src="getImage" />
    </div>
    <div class="title-area">
      <p class="category">
        {{ selectedSpotCategory }}
      </p>
      <div class="title">
        <div class="big-bold-text">{{ selectedSpot.name }}</div>
      </div>
      <p class="hour" v-if="selectedSpotParsedBusinessHours">
        {{
          selectedSpotParsedBusinessHours.filter((data) =>
            contain(data, selectedDay),
          )[0]
        }}
      </p>
    </div>
    <div class="distance-area">
      <p>{{ distance }} km</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Firebase from "./../../firebase";

export default {
  name: "drop-spot-item",
  props: {
    selectedSpot: { type: Object, default: false, required: true },
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState(["currentLat", "currentLng", "selectedSpotCommentData"]),
    selectedSpotCategory() {
      if (this.selectedSpot) {
        if (this.selectedSpot.category.id === 1) return "観光";
        else if (this.selectedSpot.category.id === 2) return "温泉";
        else if (this.selectedSpot.category.id === 3) return "食事";
        else if (this.selectedSpot.category.id === 4) return "体験";
        else if (this.selectedSpot.category.id === 5) return "お土産";
      }
      return "";
    },
    comments() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotCommentData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotCommentData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotCommentData.jyutai;
      }
    },
    getType() {
      const data = this.selectedSpot.category.id;
      if (data === 1) return "camera";
      else if (data === 2) return "spa";
      else if (data === 3) return "restaurant";
      else if (data === 4) return "experience";
      else if (data === 5) return "shopping";
    },
    getCongestionNum() {
      const data = this.selectedSpot;
      if (data.reports && data.reports.length > 0) {
        return data.reports[0].congestion;
      }
      return 0;
    },
    getCongestionCord() {
      const data = this.selectedSpot;
      const congestionNum = this.getCongestionNum;
      if (congestionNum === 1) return "_blue";
      else if (congestionNum === 2) return "_green";
      else if (congestionNum === 3) return "_yellow";
      else if (congestionNum === 4) return "_red";
      else return "_blue";
    },
    getImage() {
      const data = this.selectedSpot;

      if (data.spot_images.length !== 0) {
        return data.spot_images[0].image_url;
      }

      let name = "";
      if (data.missions && data.missions.length > 0) {
        name = this.getType + "_lock" + this.getCongestionCord + ".svg";
      } else {
        name = this.getType + "_circle" + this.getCongestionCord + ".svg";
      }

      return require(`@/assets/spots/${name}`);
    },
    selectedSpotParsedBusinessHours() {
      if (this.selectedSpot) {
        let results = null;
        if (this.selectedSpot && this.selectedSpot.business_hours != null) {
          const quoteSplit = this.selectedSpot.business_hours.split(",");
          if (quoteSplit.length > 1) {
            for (let i = 0; i < quoteSplit.length; i++) {
              const quateItem = quoteSplit[i];
              if (quateItem.match("[月火水木金土日]曜日")) {
                if (!results) {
                  results = [];
                }
                results.push(quateItem);
              }
            }
          }
        }
        return results;
      }
      return "";
    },
    distance() {
      if (this.selectedSpot) {
        const R = Math.PI / 180;
        let tmpLat = this.selectedSpot.lat;
        let tmpLng = this.selectedSpot.lon;
        let currentLat = this.currentLat;
        let currentLng = this.currentLng;
        currentLat *= R;
        currentLng *= R;
        tmpLat *= R;
        tmpLng *= R;
        const km =
          6371 *
          Math.acos(
            Math.cos(currentLat) *
              Math.cos(tmpLat) *
              Math.cos(tmpLng - currentLng) +
              Math.sin(currentLat) * Math.sin(tmpLat),
          );

        const n = 1;
        return Math.round(km * Math.pow(10, n)) / Math.pow(10, n);
      }
    },
  },
  methods: {
    ...mapMutations([
      "loadingStartMini",
      "loadingEndMini",
      "setSelectedSpotData",
    ]),
    contain(target, findText) {
      if (target == null || findText == null) return;
      return target.indexOf(findText) !== -1;
    },
    mappingType(id) {
      if (id === 1) return "camera";
      else if (id === 2) return "spa";
      else if (id === 3) return "restaurant";
      else if (id === 4) return "experience";
      else if (id === 5) return "shopping";
    },
    async onClick() {
      this.loadingStartMini();
      this.setSelectedSpotData(this.selectedSpot);
      await Firebase.getSpot(this.current);

      // ログ用の処理ここから
      let rating = null;
      if (this.comments && this.comments.length !== 0) {
        const numbers = this.comments.map((comment) => comment.Reputation);
        const sum = numbers.reduce((x, y) => x + y);
        rating = sum / numbers.length;
      }
      const actionParams = {
        name: this.selectedSpot.name,
        lat: this.selectedSpot.lat,
        lon: this.selectedSpot.lon,
        opening_hours: this.selectedSpot.business_hours,
        category: this.mappingType(this.selectedSpot.category.id),
        rating: rating,
        congestion:
          this.selectedSpot.reports.length === 0
            ? "不明"
            : this.selectedSpot.reports[0].congestion,
      };

      Firebase.putLog({
        ActionType: "SeeSpotDetail",
        ActionParams: actionParams,
      });
      // ログ用の処理ここまで
      this.$emit("click-spot");
      this.loadingEndMini();
    },
  },
  data() {
    return {
      selectedDay: "日",
      weekdayList: [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日",
      ],
    };
  },
  async mounted() {
    var date = new Date();
    var dayOfWeek = date.getDay();
    var dayOfWeekStr = this.weekdayList[dayOfWeek];
    this.selectedDay = dayOfWeekStr;
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.drop-spot-item {
  padding-top: 8px;
  overflow: scroll;
  background: white;
  border-radius: 12px;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  p {
    margin: 0;
  }
  .image {
    white-space: nowrap;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    width: 3rem;
    height: 3rem;
    img {
      width: 3rem;
      height: 3rem;
      object-fit: cover;
      border-radius: 50%;
    }
    &.noImg {
      img {
        width: 2rem;
        height: 2rem;
      }
    }
  }
  .title-area {
    width: 100%;
  }
  .hour {
    font-size: 0.75rem;
  }
  .category {
    font-size: 0.75rem;
  }
  .distance-area {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 0.5rem;
    font-size: 0.5rem;
  }
  .big-bold-text {
    font-weight: bold;
    margin: 0.2rem 0rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/DropSpotItem.vue